<template>
  <div>
    <Banner bgsrc="https://xuyuweb.oss-cn-shanghai.aliyuncs.com/productOfficial/images/solution/solution_banner2.jpg">
      <span class="w-banner_text">{{ this.$t('dSVehiclePositioning.vehicleTitle') }}</span>
    </Banner>
    <div class="w-packaging_issues">
      <XYTitle xText="ISSUES"></XYTitle>
      <Animation defaultClass="w-transform_top" animationClass="w-transform_show">
        <div class="w-issues_title">
          <h4 class="w-moduleBanner_text">{{ this.$t('dSCircularPackaging.doYouHaveTheseTroubles') }}</h4>
          <span>ISSUES</span>
        </div>
      </Animation>
      <div class="w-issues_box">
        <div v-for="item,index in issuesList" :key="index">
          <Animation defaultClass="w-transform_top" animationClass="w-transform_show">
            <div class="w-issues_item">
              <div class="w-issues_item_title">
                <span></span>
                <span class="w-button_text">{{ item.title }}</span>
              </div>
              <div class="w-paragraph_text w-issues_item_text">{{ item.text }}</div>
            </div>
          </Animation>
        </div>
      </div>
    </div>
    <div class="w-packaging_solutions w-vehicle_solutions">
      <XYTitle xText="SOLUTIONS"></XYTitle>
      <Animation defaultClass="w-transform_top" animationClass="w-transform_show">
        <div class="w-solutions_title">
          <h4 class="w-moduleBanner_text">{{ this.$t('dSCircularPackaging.weWillProvideYouWithProfessionalSolutions') }}</h4>
          <span>SOLUTIONS</span>
        </div>
      </Animation>
      <div class="w-solutions_box">
        <div class="w-solutions_left">
          <Animation defaultClass="w-transform_top" animationClass="w-transform_show">
            <div class="w-smallTitle_text">{{ this.$t('dSVehiclePositioning.solutionsLabel') }}</div>
          </Animation>
          <Animation defaultClass="w-transform_top" animationClass="w-transform_show">
            <div class="w-paragraph_text">{{ this.$t('dSVehiclePositioning.solutionsText') }}</div>
          </Animation>
          <Animation defaultClass="w-transform_top" animationClass="w-transform_show">
            <div class="w-solutions_title_text">
              <div><span class="w-nonParagraph_text">{{ this.$t('dSVehiclePositioning.nonParagraphText1') }}</span></div>
              <div><span class="w-nonParagraph_text">{{ this.$t('dSVehiclePositioning.nonParagraphText2') }}</span></div>
              <div><span class="w-nonParagraph_text">{{ this.$t('dSVehiclePositioning.nonParagraphText3') }}</span></div>
            </div>
          </Animation>
        </div>
        <div class="w-solutions_right">
          <Animation defaultClass="w-transform_top" animationClass="w-transform_show">
            <img src="https://xuyuweb.oss-cn-shanghai.aliyuncs.com/productOfficial/images/solution/solution_img_2.png" />
          </Animation>
        </div>
      </div>
    </div>
    <div class="w-packaging_highlights  w-vehicle_highlights">
      <XYTitle xText="HIGHLIGHTS"></XYTitle>
      <Animation defaultClass="w-transform_top" animationClass="w-transform_show">
        <div class="w-highlights_title">
          <h4 class="w-moduleBanner_text">{{ this.$t('dSVehiclePositioning.highlightsTitle') }}</h4>
          <span>{{ this.$t('dSVehiclePositioning.highlightsText') }}</span>
        </div>
      </Animation>
      <div class="w-highlights_list">
        <div v-for="item,index in highlightsList" :key="index">
          <Animation defaultClass="w-transform_top" animationClass="w-transform_show">
            <div class="w-highlights_item">
              <div class="w-item_img">
                <img :src="item.url" alt="#">
              </div>
              <div class="w-item_title w-bigTitle_text">
                {{ item.title }}
              </div>
              <div class="w-item_text w-paragraph_text">
                {{ item.text }}
              </div>
            </div>
          </Animation>
        </div>
      </div>
    </div>
    <div class="w-vehicle_applicationScene">
      <XYTitle xText="APPLICATION SCENARIOS"></XYTitle>
      <Animation defaultClass="w-transform_top" animationClass="w-transform_show">
        <div class="w-scene_title">
          <h4 class="w-moduleBanner_text">{{ this.$t('dSVehiclePositioning.applicationSceneTitle') }}</h4>
          <span>{{ this.$t('dSVehiclePositioning.applicationSceneText1') }}<span>{{ this.$t('dSVehiclePositioning.applicationSceneText2') }}</span>{{ this.$t('dSVehiclePositioning.applicationSceneText3') }}</span>
        </div>
      </Animation>
      <div class="w-scene_list">
        <div v-for="item,index in sceneList" :key="index">
          <Animation defaultClass="w-transform_top" animationClass="w-transform_show" :style="{display:getDisplayStyle(index)}">
            <div class="w-scene_list_block">
              <div class="w-scene_list_block_left">
                <img class="solution_icon_left" v-if="isLargeScreen" @click="prev" src="https://xuyuweb.oss-cn-shanghai.aliyuncs.com/productOfficial/images/solution/solution_icon_left.png" alt="">
                <img class="solution_icon_right" v-if="isLargeScreen" @click="next" src="https://xuyuweb.oss-cn-shanghai.aliyuncs.com/productOfficial/images/solution/solution_icon_right.png" alt="">
                <img :src="item.url" alt="">
                <div class="w-scene_list_title">{{item.title}}</div>
              </div>
              <div class="w-scene_list_block_right">
                <Animation defaultClass="w-transform_top" v-for="items in item.children" animationClass="w-transform_show">
                  <div class="w-scene_list_block_right_items">
                    <div class="w-scene_list_block_right_items_title">
                      <div class="blue_ring"></div> {{items.title}}
                    </div>
                    <div class="w-scene_list_block_right_items_text">{{items.text}}</div>
                  </div>
                </Animation>
              </div>
            </div>
          </Animation>
        </div>
      </div>
    </div>
    <div class="w-vehicle_locators">
      <XYTitle xText="LOCATORS"></XYTitle>
      <Animation defaultClass="w-transform_top" animationClass="w-transform_show">
        <div class="w-locators_title">
          <h4 class="w-moduleBanner_text">{{ this.$t('dSVehiclePositioning.locatorsTitle') }}</h4>
        </div>
      </Animation>
      <Animation defaultClass="w-transform_top" animationClass="w-transform_show">
        <div class="w-locators_imagewarp">
          <div class="w-locators_imagecontent" @click="handProduct('D98')">
            <img src="https://xuyuweb.oss-cn-shanghai.aliyuncs.com/productOfficial/images/common/common_img_product4.png" alt="">
            <div>
              <div class="w-hover_move">
                <span class="w-moduleBanner_text w_xuyu">D98</span>
                <div class="w_aboutUsMore w-transform_timing">
                  <span class="w-button_text">{{ this.$t('home.viewMore') }}</span>
                  <i class="iconfont icon-common_icon_more w-button_text"></i>
                </div>
              </div>
            </div>
          </div>
          <div class="w-locators_imagecontent" @click="handProduct('D60')">
            <img src="https://xuyuweb.oss-cn-shanghai.aliyuncs.com/productOfficial/images/common/common_img_product5.png" alt="">
            <div>
              <div class="w-hover_move">
                <span class="w-moduleBanner_text w_xuyu">D60</span>
                <div class="w_aboutUsMore w-transform_timing">
                  <span class="w-button_text">{{ this.$t('home.viewMore') }}</span>
                  <i class="iconfont icon-common_icon_more w-button_text"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Animation>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import Banner from '@/components/Banner'
import XYTitle from '@/components/XYTitle.vue'
import Animation from '@/components/Animation.vue'
import Footer from '@/components/Footer.vue'
export default {
  props: {

  },
  data () {
    return {
      isLargeScreen: window.innerWidth > 480,
      issuesList: [{
        id: 1,
        title: this.$t('dSVehiclePositioning.issuesItemTitle1'),
        text: this.$t('dSVehiclePositioning.issuesItemtext1')
      }, {
        id: 2,
        title: this.$t('dSVehiclePositioning.issuesItemTitle2'),
        text: this.$t('dSVehiclePositioning.issuesItemtext2')
      }, {
        id: 3,
        title: this.$t('dSVehiclePositioning.issuesItemTitle3'),
        text: this.$t('dSVehiclePositioning.issuesItemtext3')
      }, {
        id: 4,
        title: this.$t('dSVehiclePositioning.issuesItemTitle4'),
        text: this.$t('dSVehiclePositioning.issuesItemtext4')
      }, {
        id: 5,
        title: this.$t('dSVehiclePositioning.issuesItemTitle5'),
        text: this.$t('dSVehiclePositioning.issuesItemtext5')
      },
      ],
      highlightsList: [{
        id: 1,
        url: 'https://xuyuweb.oss-cn-shanghai.aliyuncs.com/productOfficial/images/solution/solution_img_highlight9.png',
        title: this.$t('dSVehiclePositioning.highlightsItemTitle1'),
        text: this.$t('dSVehiclePositioning.highlightsItemtext1')
      }, {
        id: 2,
        url: 'https://xuyuweb.oss-cn-shanghai.aliyuncs.com/productOfficial/images/solution/solution_img_highlight10.png',
        title: this.$t('dSVehiclePositioning.highlightsItemTitle2'),
        text: this.$t('dSVehiclePositioning.highlightsItemtext2')
      }, {
        id: 3,
        url: 'https://xuyuweb.oss-cn-shanghai.aliyuncs.com/productOfficial/images/solution/solution_img_highlight11.png',
        title: this.$t('dSVehiclePositioning.highlightsItemTitle3'),
        text: this.$t('dSVehiclePositioning.highlightsItemtext3')
      }, {
        id: 4,
        url: 'https://xuyuweb.oss-cn-shanghai.aliyuncs.com/productOfficial/images/solution/solution_img_highlight12.png',
        title: this.$t('dSVehiclePositioning.highlightsItemTitle4'),
        text: this.$t('dSVehiclePositioning.highlightsItemtext4')
      }],
      sceneList: [
        {
          id: 1,
          url: 'https://xuyuweb.oss-cn-shanghai.aliyuncs.com/productOfficial/images/solution/solution_img_application7.png',
          title: this.$t('dSVehiclePositioning.sceneItemLabel1'),
          children: [
            {
              id: 11,
              title: this.$t('dSVehiclePositioning.sceneItemTitle1'),
              text: this.$t('dSVehiclePositioning.sceneItemText1')
            },
            {
              id: 12,
              title: this.$t('dSVehiclePositioning.sceneItemTitle2'),
              text: this.$t('dSVehiclePositioning.sceneItemText2')
            },
            {
              id: 13,
              title: this.$t('dSVehiclePositioning.sceneItemTitle3'),
              text: this.$t('dSVehiclePositioning.sceneItemText3')
            },
            {
              id: 14,
              title: this.$t('dSVehiclePositioning.sceneItemTitle4'),
              text: this.$t('dSVehiclePositioning.sceneItemText4')
            },
          ]
        },
        {
          id: 2,
          url: 'https://xuyuweb.oss-cn-shanghai.aliyuncs.com/productOfficial/images/solution/solution_img_application8.png',
          title: this.$t('dSVehiclePositioning.sceneItemLabel2'),
          children: [
            {
              id: 21,
              title: this.$t('dSVehiclePositioning.sceneItemTitle5'),
              text: this.$t('dSVehiclePositioning.sceneItemText5')
            },
            {
              id: 22,
              title: this.$t('dSVehiclePositioning.sceneItemTitle6'),
              text: this.$t('dSVehiclePositioning.sceneItemText6')
            },
            {
              id: 23,
              title: this.$t('dSVehiclePositioning.sceneItemTitle7'),
              text: this.$t('dSVehiclePositioning.sceneItemText7')
            },
            {
              id: 24,
              title: this.$t('dSVehiclePositioning.sceneItemTitle8'),
              text: this.$t('dSVehiclePositioning.sceneItemText8')
            },
          ]
        },
        {
          id: 3,
          url: 'https://xuyuweb.oss-cn-shanghai.aliyuncs.com/productOfficial/images/solution/solution_img_application9.png',
          title: this.$t('dSVehiclePositioning.sceneItemLabel3'),
          children: [
            {
              id: 31,
              title: this.$t('dSVehiclePositioning.sceneItemTitle9'),
              text: this.$t('dSVehiclePositioning.sceneItemText9')
            },
            {
              id: 32,
              title: this.$t('dSVehiclePositioning.sceneItemTitle10'),
              text: this.$t('dSVehiclePositioning.sceneItemText10')
            },
            {
              id: 33,
              title: this.$t('dSVehiclePositioning.sceneItemTitle11'),
              text: this.$t('dSVehiclePositioning.sceneItemText11')
            },
            {
              id: 34,
              title: this.$t('dSVehiclePositioning.sceneItemTitle12'),
              text: this.$t('dSVehiclePositioning.sceneItemText12')
            },
          ]
        },
        {
          id: 4,
          url: 'https://xuyuweb.oss-cn-shanghai.aliyuncs.com/productOfficial/images/solution/solution_img_application10.png',
          title: this.$t('dSVehiclePositioning.sceneItemLabel4'),
          children: [
            {
              id: 11,
              title: this.$t('dSVehiclePositioning.sceneItemTitle13'),
              text: this.$t('dSVehiclePositioning.sceneItemText13')
            },
            {
              id: 12,
              title: this.$t('dSVehiclePositioning.sceneItemTitle14'),
              text: this.$t('dSVehiclePositioning.sceneItemText14')
            },
            {
              id: 13,
              title: this.$t('dSVehiclePositioning.sceneItemTitle15'),
              text: this.$t('dSVehiclePositioning.sceneItemText15')
            },
            {
              id: 14,
              title: this.$t('dSVehiclePositioning.sceneItemTitle16'),
              text: this.$t('dSVehiclePositioning.sceneItemText16')
            },
          ]
        },
      ],
      currentIndex: 0,
    };
  },
  methods: {
    prev () {
      this.currentIndex = (this.currentIndex - 1 + this.sceneList.length) % this.sceneList.length;
    },
    next () {
      this.currentIndex = (this.currentIndex + 1) % this.sceneList.length;
    },
    getDisplayStyle (index) {
      if (this.isLargeScreen)      {
        return this.currentIndex === index ? 'block' : 'none';
      }
      return 'block';
    },
    handleResize () {
      this.isLargeScreen = window.innerWidth > 480;
    },
    handProduct(data){
      this.$emit('openProdect', { activeId: 2, menuName: 'ProductDetail', prodectId: data })
    }
  },
  components: {
    Banner, XYTitle, Animation, Footer
  },
  mounted () {
    // 监听窗口大小变化
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy () {
    // 移除窗口大小变化监听，防止内存泄漏
    window.removeEventListener('resize', this.handleResize);
  },
};
</script>

<style scoped>
</style>
